import { foldEvents } from './fold';
import { repairState } from './repair';
/**
 * Where an intervento stands, as one value: the list's chip and its filter.
 * `senza_esito` is a completed intervento without an outcome (rows completed
 * before the esito was required).
 */
export const stati = [
    'bozza',
    'in_corso',
    'senza_esito',
    'positivo',
    'negativo',
    'in_riparazione',
    'riparato',
];
const lifecycle = new Set([
    'creato',
    'avviato',
    'completato',
]);
/**
 * The stato from the events alone, the row's status and esito only where no
 * event decides them: a row without lifecycle events (no operatore to record
 * them as). Before completion repair events change nothing (they can arrive
 * before the completion from another device); after it an open repair wins,
 * then the current esito, positive after a repair closed meaning `riparato`.
 */
export function statoOf(events, row, 
/** The events' fold, when the caller has it already */
folded) {
    let hasLifecycle = false;
    let completed = false;
    let started = false;
    for (const event of events) {
        if (lifecycle.has(event.tipo))
            hasLifecycle = true;
        if (event.tipo === 'completato')
            completed = true;
        else if (event.tipo === 'avviato')
            started = true;
    }
    if (hasLifecycle && !completed)
        return started ? 'in_corso' : 'bozza';
    if (!hasLifecycle && row.status !== 'completato')
        return row.status;
    // Completed. The common case, a completion without repairs nor corrections,
    // still folds: the first of two completions wins, and the fold knows which
    const fold = folded ?? foldEvents(events);
    if (fold.openRepair)
        return 'in_riparazione';
    const repaired = fold.phases.some((phase) => phase.kind === 'repair' && phase.closingId !== null && !phase.cancelled);
    // Without lifecycle events the inspection's esito is the row's
    const esito = hasLifecycle || repaired ? fold.currentEsito : row.esito;
    if (esito === null)
        return 'senza_esito';
    if (esito === 'negativo')
        return 'negativo';
    return repaired ? 'riparato' : 'positivo';
}
/** The stato and the repairs, from one fold: the chip and the filters need both. */
export function statoAndRepairOf(events, row) {
    const fold = foldEvents(events);
    return { stato: statoOf(events, row, fold), repair: repairState(fold) };
}
